// extracted by mini-css-extract-plugin
export default {"clientPicker":"ClientsPicker-module__clientPicker--nS4Ew"};